module.exports = __webpack_public_path__ + "img/6.1f6fcc0f.png";